document.addEventListener('DOMContentLoaded', function() {
  // Configuración con variables responsive
  let menuHeight = window.innerWidth <= 768 ? 65 : 65; 
  let anchorLinkOffset = 65; // Espacio adicional para los anchor links
  const totalOffset = menuHeight + anchorLinkOffset; // Offset total combinado
  const menuLinks = document.querySelectorAll('.anchor-menu__link');
  const anchorMenu = document.querySelector('.anchor-menu');
  const sections = [];
  
  // Tracking de estado
  let menuIsSticky = false;
  let isFirstPageLoad = true;
  
  // Actualizar variables cuando cambie el tamaño de la ventana
  window.addEventListener('resize', function() {
    menuHeight = window.innerWidth <= 768 ? 65 : 65;
    updateStyles(); 
    checkStickyMenu(); 
  });
  
  // Obtener la posición original del menú de anclaje para referencia
  let anchorMenuOriginalPosition = 0;
  if (anchorMenu) {
    // Establecer posición original en cuanto sea posible
    window.addEventListener('DOMContentLoaded', function() {
      anchorMenuOriginalPosition = anchorMenu.getBoundingClientRect().top + window.pageYOffset;
    });
    
    // Y confirmarla después de la carga completa
    window.addEventListener('load', function() {
      anchorMenuOriginalPosition = anchorMenu.getBoundingClientRect().top + window.pageYOffset;
    });
  }
  
  // Función para actualizar estilos CSS dinámicamente
  function updateStyles() {
    const styleEl = document.getElementById('anchor-menu-styles') || document.createElement('style');
    styleEl.id = 'anchor-menu-styles';
    styleEl.textContent = `
      [id] {
        scroll-margin-top: ${totalOffset}px; /* Offset total como margen de scroll */
      }
      .section-anchor-menu {
        padding-top: ${menuHeight}px;
      }
      .anchor-menu--sticky {
        position: fixed !important;
        top: ${menuHeight}px !important; 
        z-index: 90;
        width: 100%;
        background: #fff;
      }
    `;
    if (!document.getElementById('anchor-menu-styles')) {
      document.head.appendChild(styleEl);
    }
  }
  
  // Aplicar estilos iniciales
  updateStyles();
  
  // Detector de scroll para añadir/quitar clase sticky con precisión
  function checkStickyMenu() {
    if (!anchorMenu || anchorMenuOriginalPosition === 0) return;
    
    // Obtener la posición actual de la ventana
    const scrollY = window.pageYOffset;
    
    // Calcular el punto exacto en el que el anchorMenu tocaría el menú principal
    const adjustment = window.innerWidth <= 860 ? 115 : 145;
    const stickyPoint = anchorMenuOriginalPosition - menuHeight - adjustment;
    
    // Determinar si el menú debe ser sticky
    const shouldBeSticky = scrollY >= stickyPoint;
    
    // Solo hacer cambios si el estado ha cambiado
    if (shouldBeSticky !== menuIsSticky) {
      menuIsSticky = shouldBeSticky;
      
      if (menuIsSticky) {
        anchorMenu.classList.add('anchor-menu--sticky');
      } else {
        anchorMenu.classList.remove('anchor-menu--sticky');
      }
    }
  }
  
  // Recolectar todas las secciones correspondientes a los enlaces
  menuLinks.forEach(link => {
    const targetId = link.getAttribute('href').replace('#', '');
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      sections.push({
        link: link,
        section: targetSection
      });
    }
  });

  // Activar el primer enlace por defecto
  if (menuLinks.length > 0) {
    menuLinks[0].classList.add('anchor-menu__link--active');
  }

  // Función crucial para calcular la posición correcta según el estado del menú
  function calculateTargetPosition(targetSection) {
    const rect = targetSection.getBoundingClientRect();
    const windowScrollY = window.pageYOffset;
    
    // Si es la primera carga de página o el menú no es sticky,
    // necesitamos un ajuste adicional en ciertos navegadores
    let adjustedOffset = totalOffset;
    
    // Crear un objeto de opciones para el scroll
    const scrollOptions = {
      top: rect.top + windowScrollY - adjustedOffset,
      behavior: 'smooth'
    };
    
    console.log("Scroll to:", scrollOptions.top, "Offset:", adjustedOffset, "Sticky:", menuIsSticky);
    
    return scrollOptions.top;
  }

  // Función para manejar clics en los enlaces
  function handleLinkClick(e) {
    e.preventDefault();
    
    const targetId = this.getAttribute('href').replace('#', '');
    const targetSection = document.getElementById(targetId);
    
    if (targetSection) {
      // Calcular la posición correcta según el estado actual
      const targetPosition = calculateTargetPosition(targetSection);
      
      // Guardar referencia al enlace clickeado
      const clickedLink = this;
      
      // Variable para manejar el scroll programático
      let isScrollingProgrammatically = true;
      
      // Reemplazar temporalmente la función updateActiveLink
      const originalUpdateActiveLink = updateActiveLink;
      
      // Sobrescribir la función para que no haga nada durante el scroll programático
      window.updateActiveLink = function() {
        // No hacer nada durante el scroll programático
      };
      
      // Establecer manualmente el link activo ANTES del scroll
      menuLinks.forEach(link => link.classList.remove('anchor-menu__link--active'));
      clickedLink.classList.add('anchor-menu__link--active');
      
      // SOLUCIÓN PARA PRIMER CLIC SIN SCROLL: hacer scroll explícito al elemento
      if (isFirstPageLoad) {
        // Forzar el primer scroll con un offset muy específico
        const additionalOffset = menuIsSticky ? 0 : anchorLinkOffset;
        
        // Hacer scroll con el offset ajustado según el estado del menú
        window.scrollTo({
          top: targetPosition - additionalOffset,
          behavior: 'smooth'
        });
        
        isFirstPageLoad = false;
      } else {
        // Scroll normal para navegación subsecuente
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
      
      // Centrar el elemento activo en dispositivos móviles
      if (window.innerWidth <= 860) {
        const menuContainer = document.querySelector('.anchor-menu__container');
        if (menuContainer) {
          const containerWidth = menuContainer.offsetWidth;
          const linkWidth = clickedLink.offsetWidth;
          const linkOffset = clickedLink.offsetLeft;
          const scrollPosition = linkOffset - (containerWidth / 2) + (linkWidth / 2);
          
          menuContainer.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      }
      
      // Esperar a que termine la animación de scroll
      setTimeout(function() {
        // Asegurarnos de que el enlace clickeado sigue siendo el activo
        menuLinks.forEach(link => link.classList.remove('anchor-menu__link--active'));
        clickedLink.classList.add('anchor-menu__link--active');
        
        // Restaurar la función original después de un tiempo
        window.updateActiveLink = originalUpdateActiveLink;
        isScrollingProgrammatically = false;
      }, 1000); // Tiempo suficiente para la animación y para evitar interferencias
    }
  }

  // Agregar manejadores de clic a los enlaces
  menuLinks.forEach(link => {
    link.addEventListener('click', handleLinkClick);
  });

  // Función para actualizar enlaces activos al hacer scroll
  function updateActiveLink() {
    // Usar un algoritmo diferente para detectar la sección activa
    // Vamos a recorrer las secciones desde el final hacia el principio
    // para encontrar la primera que esté visible en la pantalla
    let currentSectionIndex = -1;
    
    // Recorrer en orden inverso (de abajo hacia arriba)
    for (let i = sections.length - 1; i >= 0; i--) {
      const rect = sections[i].section.getBoundingClientRect();
      
      // Una sección se considera visible si su parte superior está cerca o por debajo
      // del borde superior de la ventana, pero todavía dentro de la primera mitad de la pantalla
      if (rect.top <= menuHeight + (window.innerHeight * 0.2)) {
        currentSectionIndex = i;
        break; // Importante: salir del bucle en cuanto encontremos una sección visible
      }
    }

    if (currentSectionIndex !== -1) {
      const previousActive = document.querySelector('.anchor-menu__link--active');
      const newActive = sections[currentSectionIndex].link;
      
      if (previousActive !== newActive) {
        menuLinks.forEach(link => link.classList.remove('anchor-menu__link--active'));
        newActive.classList.add('anchor-menu__link--active');
        
        if (window.innerWidth <= 764) {
          const menuContainer = document.querySelector('.anchor-menu__container');
          if (menuContainer) {
            const containerWidth = menuContainer.offsetWidth;
            const linkWidth = newActive.offsetWidth;
            const linkOffset = newActive.offsetLeft;
            const scrollPosition = linkOffset - (containerWidth / 2) + (linkWidth / 2);
            
            menuContainer.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  }

  // Inicializar los eventos
  window.addEventListener('load', function() {
    checkStickyMenu();
    
    // Comprobar si hay un hash en la URL
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const targetSection = document.getElementById(hash);
      
      if (targetSection) {
        setTimeout(function() {
          const targetLink = document.querySelector(`.anchor-menu__link[href="#${hash}"]`);
          if (targetLink) {
            targetLink.click(); // Usar el handler de clic existente
          }
        }, 100);
      }
    }
  });
  
  // Variable para rastrear si estamos en scroll programático
  let inProgrammaticScroll = false;
  
  // Manejar eventos de scroll
  window.addEventListener('scroll', function() {
    checkStickyMenu();
    
    // Solo actualizar el enlace activo si no estamos en scroll programático
    if (!inProgrammaticScroll) {
      updateActiveLink();
    }
  });
});